import { boronClient } from "../../../api";
import { useBoronMutation } from "../../../hooks/http/useBoronMutation";
import { useKarteTemplatesCacheUpdater } from "../../../hooks/http/useFetchKarteTemplates";
import { useSectionKarteTemplateCacheUpdater } from "./useFetchSectionKarteTemplate";

export const useDeleteSectionKarteTemplate = ({
  sectionId,
  karteTemplateId,
}: {
  sectionId: string;
  karteTemplateId: string;
}) => {
  const { removeKarteTemplate } = useKarteTemplatesCacheUpdater();
  const { removeSectionKarteTemplate } = useSectionKarteTemplateCacheUpdater();

  return useBoronMutation(
    async () =>
      await boronClient.DELETE(
        "/api/v1/sections/{section_id}/karte_templates/{karte_template_hashid}",
        {
          params: {
            path: {
              section_id: sectionId,
              karte_template_hashid: karteTemplateId,
            },
          },
        },
      ),
    {
      onSuccess: () => {
        removeKarteTemplate(sectionId, karteTemplateId);
        removeSectionKarteTemplate(sectionId, karteTemplateId);
      },
    },
  );
};
